module.exports = __webpack_public_path__ + "img/logo10.60847a0f.png";